import { Icon } from "../../models/icon";

export default function InstoreOrderIcon({
  selected = false,
  color = "#000000",
  selectedColor = "#9eab80",
  outline = "#3e5902",
  width = 24,
}: Icon) {
  return (
    <svg viewBox="0 0 80 80" style={{ width: width + "px" }}>
      <g id="blue_circle" data-name="blue circle">
        <path
          fill={selected ? selectedColor : color}
          d="M40,0C17.94,0,0,17.94,0,40s17.94,40,40,40,40-17.94,40-40S62.06,0,40,0Z"
        />
        <g>
          <path
            fill={selected ? outline : "white"}
            d="M57.59,19.93c-.88-.88-2.12-1.38-3.38-1.38h-28.42c-1.27,0-2.5.5-3.38,1.38-2.37,2.36-4.11,5.86-4.81,9.64h44.79c-.69-3.78-2.44-7.28-4.8-9.64Z"
          />
          <path
            fill={selected ? outline : "white"}
            d="M62.71,32.8H17.29c-.02,2.55.56,4.75,1.67,6.18.47.6,1.14.98,1.86,1.08v16.57c0,2.66,2.17,4.83,4.83,4.83h28.71c2.66,0,4.83-2.17,4.83-4.83v-16.57c.72-.1,1.39-.48,1.86-1.08,1.09-1.41,1.67-3.57,1.67-6.07,0-.03,0-.07,0-.1ZM56.88,56.63c0,1.39-1.13,2.52-2.52,2.52h-8.06v-11.92c0-1.31-1.07-2.38-2.38-2.38h-7.83c-1.31,0-2.38,1.07-2.38,2.38v11.92h-8.06c-1.39,0-2.52-1.13-2.52-2.52v-17.2s0,0,0,0c.06-.04.11-.07.16-.11.02-.01.03-.02.05-.03.04-.03.07-.05.11-.08.02-.01.03-.03.05-.04.03-.03.07-.05.1-.08.01-.01.03-.02.04-.03.04-.04.09-.07.13-.11.56-.45.89-.72,1.7-.72s1.14.27,1.7.72c.64.52,1.53,1.24,3.15,1.24s2.51-.72,3.15-1.24c.56-.45.89-.72,1.7-.72s1.14.27,1.7.72c.64.52,1.53,1.24,3.15,1.24s2.5-.72,3.15-1.24c.56-.45.89-.72,1.7-.72s1.14.27,1.69.72c.65.52,1.53,1.24,3.15,1.24s2.5-.72,3.15-1.24c.56-.45.89-.72,1.69-.72s1.14.27,1.7.72c.04.03.09.07.13.11.01.01.03.02.04.03.03.03.07.05.1.08.02.01.03.03.05.04.04.03.07.05.11.08.02.01.03.02.05.03.05.04.11.08.16.11,0,0,0,0,0,0v17.2Z"
          />
        </g>
      </g>
    </svg>
  );
}


